module.exports = __webpack_public_path__ + "static/media/plane.b10a36cf.svg";